import { AsyncDataHandler } from '@ds';
import { memo } from 'react';
import { useGetBeneficiaryResourceDocument } from 'src/shared/queries/useGetBeneficiaryResourceDocument';
import styles from './Processes.module.scss';

const Processes = (props: { caseId: number }) => {
  const { caseId } = props;
  const { data: processes, isLoading } = useGetBeneficiaryResourceDocument(caseId);

  return (
    <AsyncDataHandler isLoading={isLoading} loader={{ width: '200px', height: '32px' }}>
      {processes && processes.length > 0 && (
        <div className={styles['processes-content']}>
          <div className={styles['processes-title']}>
            <span>Case processes</span>
          </div>
          <div className={styles['processes-list']}>
            {processes.map((item, index: number) => (
              <a key={index} target="_blank" href={`/pdfPreview?file=${encodeURIComponent(item.fileUrl)}`}>
                {item.docTypeName}
              </a>
            ))}
          </div>
        </div>
      )}
    </AsyncDataHandler>
  );
};

export default memo(Processes);
